import { z } from 'zod';
export const stDischargeValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        visitIncluded: z.string().optional(),
        visitNotIncludedReason: z.string().optional(),
        summary: z
            .object({
            referringPhysician: z.string().optional(),
            evaluationDate: z.string().nullish(),
            dcDate: z.string().nullish(),
            certificationPeriod: z.string().optional(),
            numberOfVisitsExpected: z.string().optional(),
            numberOfVisitsCompleted: z.string().optional(),
            disciplinesStillProvidingCare: z.array(z.string()).optional(),
            dateOfLastVisit: z.string().nullish(),
            initialReasonForHomeTherapy: z.string().optional(),
            barriersToProgressDuringTherapy: z.string().optional(),
            reasonForDischarge: z.string().optional(),
        })
            .optional(),
        hepUpdate: z.array(z.string()).optional(),
        statusSwallowing: z
            .object({
            oralPhase: z.string().optional(),
            pharyngealStage: z.string().optional(),
            safestConsistencyLiquids: z.string().optional(),
            safestConsistencySolids: z.string().optional(),
            nutritionUpdate: z.string().optional(),
        })
            .optional(),
        statusCognitive: z
            .object({
            attention: z.string().optional(),
            organizationOfThoughts: z.string().optional(),
            recall: z.string().optional(),
            safetyAwareness: z.string().optional(),
        })
            .optional(),
        goalStatus: z
            .object({
            status: z.string().optional(),
            goalsNotMetExplanation: z.string().optional(),
        })
            .optional(),
        outcomeMeasures: z
            .object({
            types: z.array(z.string()).optional(),
            specify: z.string().optional(),
        })
            .optional(),
        levelOfAssistance: z
            .object({
            names: z.string().optional(),
            availability: z.array(z.string()).optional(),
            availabilityOther: z.string().optional(),
            from: z.array(z.string()).optional(),
            fromOther: z.string().optional(),
        })
            .optional(),
        patientNotifiedOfDischarge: z
            .object({
            notified: z.string().optional(),
            date: z.string().optional(),
        })
            .optional(),
        physicianNotifiedOfDischarge: z
            .object({
            notified: z.string().optional(),
            date: z.string().optional(),
        })
            .optional(),
        dischargeNotice: z
            .object({
            notified: z.string().optional(),
            notifiedExplain: z.string().optional(),
        })
            .optional(),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
